/**
 * Property managers (Bewirtschafter) domain API functions (Step 7.1.10).
 *
 * List, get, create, update property managers; units and notes sub-resources.
 * Extracted from adminData/index.js for team scalability.
 */
import {
  API_BASE_URL,
  getApiHeaders,
  parseAdminErrorResponse,
  parseAdminErrorBodyText,
} from "./core";

/**
 * Property managers (Bewirtschafter). List; create/update for admin page.
 */
export function fetchAdminPropertyManagers() {
  return fetch(`${API_BASE_URL}/api/admin/property-managers`, {
    headers: getApiHeaders(),
  }).then((res) => {
    if (!res.ok) throw new Error("Bewirtschafter konnten nicht geladen werden.");
    return res.json();
  });
}

export function fetchAdminPropertyManager(id) {
  const base = `${API_BASE_URL}/api/admin/property-managers/${encodeURIComponent(id)}`;
  const sep = base.includes("?") ? "&" : "?";
  return fetch(`${base}${sep}_=${Date.now()}`, {
    headers: getApiHeaders(),
  }).then((res) => {
    if (!res.ok) {
      if (res.status === 404) return null;
      throw new Error("Bewirtschafter konnte nicht geladen werden.");
    }
    return res.json();
  });
}

export function fetchAdminPropertyManagerUnits(propertyManagerId) {
  return fetch(
    `${API_BASE_URL}/api/admin/property-managers/${encodeURIComponent(propertyManagerId)}/units`,
    { headers: getApiHeaders() }
  ).then((res) => {
    if (!res.ok) {
      if (res.status === 404) return [];
      throw new Error("Units konnten nicht geladen werden.");
    }
    return res.json();
  });
}

export function fetchAdminPropertyManagerNotes(propertyManagerId) {
  return fetch(
    `${API_BASE_URL}/api/admin/property-managers/${encodeURIComponent(propertyManagerId)}/notes`,
    { headers: getApiHeaders() }
  ).then((res) => {
    if (!res.ok) {
      if (res.status === 404) return { items: [] };
      throw new Error("Notizen konnten nicht geladen werden.");
    }
    return res.json();
  });
}

export async function createAdminPropertyManagerNote(propertyManagerId, content) {
  const res = await fetch(
    `${API_BASE_URL}/api/admin/property-managers/${encodeURIComponent(propertyManagerId)}/notes`,
    {
      method: "POST",
      headers: getApiHeaders(),
      body: JSON.stringify({ content }),
    }
  );
  const text = await res.text();
  if (!res.ok) {
    throw new Error(parseAdminErrorBodyText(text));
  }
  try {
    return text ? JSON.parse(text) : {};
  } catch (e) {
    console.warn("createAdminPropertyManagerNote: unexpected response body", e);
    throw new Error("Notiz konnte nicht gespeichert werden.");
  }
}

export async function createAdminPropertyManager(body) {
  const res = await fetch(`${API_BASE_URL}/api/admin/property-managers`, {
    method: "POST",
    headers: getApiHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(await parseAdminErrorResponse(res));
  }
  return res.json();
}

export async function patchAdminPropertyManager(id, body) {
  const res = await fetch(`${API_BASE_URL}/api/admin/property-managers/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: getApiHeaders(),
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(await parseAdminErrorResponse(res));
  }
  return res.json();
}
